export default "__VITE_ASSET__dd495c5b__"